<template>
  <div class="complete-card">
    <div class="complete-time">
      <div class="complete-date">{{item.dateFinish.date}}</div>
      <div class="complete-day">
        <div class="complete-weekday">{{item.dateFinish.day}}</div>
        <div class="complete-month">{{item.dateFinish.month}}</div>
      </div>
      <div class="complete-hour">{{item.dateFinish.hour}}</div>
    </div>
    <div class="complete-item">
      <h2>{{item.title}}</h2>
    </div>
    <div class="complete-card-btn">
      <div @click="goBack">
        <svg
          height="20"
          width="20"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          style="margin-bottom: 3px; margin-right:1px"
        >
        <path
     d="M 7.695358,5.6369709 V 2.0001633 c 0,-0.2377246 -0.1371517,-0.2948738 -0.3040193,-0.1257202 L 0.12686576,9.1434863 c -0.1691545,0.1691536 -0.1691545,0.4411677 0,0.6103296 L 7.3890527,17.016001 c 0.1691536,0.169154 0.3040194,0.112004 0.3040194,-0.125728 v -3.748812 c 0,-0.237733 0.1942985,-0.432024 0.432028,-0.42746 5.2323409,0.08687 8.9720129,1.785261 11.6921889,5.385493 0.14401,0.189727 0.217158,0.157732 0.166869,-0.0754 C 18.800081,12.645454 15.503866,7.3673935 8.1205289,6.1330266 7.8873706,6.0942144 7.695358,5.8747283 7.695358,5.6369955 Z"
     class="svg"
     style="stroke-width:0.0228586" />
        </svg>
      </div>
      <div @click="deleteItem">
        <svg
          height="18"
          width="18"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m 319.73683,110.87999 c -38.95639,-0.19999 -77.91294,-0.0401 -116.82944,-0.0401 -41.19624,0 -82.43238,-0.27998 -123.62877,0.15998 -20.558,0.19999 -25.43756,5.59949 -22.67785,25.67767 10.87897,79.2328 22.23792,158.38561 33.47687,237.53842 2.99986,21.19807 8.23925,25.67767 29.67741,25.71765 55.31489,0.0801 110.62994,0.0801 165.94485,0.0401 23.75794,0 29.11733,-5.87947 31.91709,-29.27734 9.03916,-76.07309 18.43845,-152.10618 28.31741,-228.05927 3.43979,-26.27762 0,-31.59714 -26.19757,-31.75711 z M 138.31334,358.13753 c -13.43874,1.63985 -18.47835,-9.15917 -19.83818,-20.51814 -6.51943,-54.75503 -12.63883,-109.59004 -18.95832,-164.34506 -1.23999,-10.87902 1.9598,-20.07819 13.27885,-21.95801 12.47879,-2.07982 18.55829,6.79937 20.03812,17.87837 4.27959,32.35707 7.99926,64.79411 11.83892,97.19117 2.63972,22.35798 5.1596,44.71595 7.71937,67.07391 1.19994,11.75894 -0.48057,23.0379 -14.07876,24.67776 z m 80.35272,-20.67813 c -0.0445,11.15899 -4.67962,21.27807 -16.95847,21.07808 -13.19875,-0.23998 -16.79843,-10.59903 -16.67858,-22.71793 0.28033,-26.99754 0.0742,-54.03509 0.0742,-81.03263 h -0.28033 c 0,-26.99756 0.11866,-54.03509 -0.0445,-81.03265 -0.0742,-11.59894 1.91976,-22.83792 15.63854,-23.55786 13.79872,-0.71996 17.79843,10.35906 17.87837,21.83802 0.44053,55.115 0.48057,110.26998 0.36043,165.42497 z m 86.75202,-162.66521 c -6.59937,54.75502 -13.51869,109.43006 -20.59804,164.14509 -1.44023,11.03899 -7.31934,20.51812 -19.4782,18.75829 -13.07891,-1.91983 -15.3186,-12.63885 -13.67888,-24.63777 3.67977,-26.75756 6.63943,-53.59513 10.07921,-80.3927 3.43963,-26.79756 6.95936,-53.55512 10.19905,-80.39268 1.40018,-11.51896 4.79947,-22.39797 18.51824,-21.39806 13.75883,0.99985 16.31861,12.51887 14.95862,23.91783 z M 169.67051,34.606917 c 6.71937,-33.5569512 10.19905,-37.0366353 32.717,-33.5169549 38.31653,5.999455 39.31639,7.2393427 34.31682,44.5559529 29.59732,5.239523 59.23467,10.919009 89.03191,15.598582 12.91887,2.039815 24.5178,5.039542 22.31801,21.038092 -2.35983,17.118439 -16.23851,14.758657 -27.83744,12.838833 C 251.42312,83.602465 182.66932,71.603557 113.91553,59.764632 98.95691,57.164869 84.03818,54.165141 68.99962,51.925343 56.92071,50.125508 49.96135,43.846078 52.04115,31.567193 54.20089,18.968337 63.84002,16.128596 75.19912,18.088417 c 31.51706,5.399511 62.99423,10.999001 94.47139,16.5185 z"
            style="stroke-width:0.399963"
          />
          <path
            d="m 14.388157,4.9895839 c -1.753037,-0.00885 -3.506096,-0.0018 -5.257317,-0.0018 -1.8538363,0 -3.7094416,-0.012699 -5.5632779,0.00725 -0.9251152,0.00885 -1.1446984,0.2519752 -1.020518,1.1554926 0.4895548,3.5654636 1.0007209,7.1273285 1.5064671,10.6891965 0.1349293,0.953908 0.3707718,1.15549 1.3354815,1.15729 2.4891599,0.0036 4.9783203,0.0036 7.4675023,0.0018 1.069092,0 1.310287,-0.264576 1.436259,-1.317478 0.40676,-3.423278 0.829712,-6.8447566 1.274275,-10.2626357 0.154659,-1.1824899 0,-1.4218679 -1.178872,-1.4290655 z M 6.2241023,16.116142 C 5.6193701,16.189932 5.3925757,15.703978 5.3313927,15.192826 5.0380181,12.728859 4.7626492,10.26129 4.4782775,7.7973219 4.4224919,7.3077644 4.5664919,6.8938043 5.0758209,6.8092139 c 0.5615322,-0.093589 0.8351323,0.3059717 0.9017124,0.8045224 0.1925292,1.456065 0.3599775,2.9157277 0.5327549,4.3735907 0.1188284,1.006106 0.2321689,2.012213 0.3473689,3.018317 0.053971,0.529153 -0.022677,1.036703 -0.6335548,1.110498 z M 9.839955,15.185626 c -0.0018,0.502155 -0.210444,0.957509 -0.76311,0.948514 -0.5939604,-0.01088 -0.7559205,-0.476958 -0.7505457,-1.022307 0.01134,-1.214884 0.00454,-2.431569 0.00454,-3.646458 h -0.01134 c 0,-1.214884 0.00677,-2.4315692 -0.0018,-3.6464581 C 8.3131593,7.296968 8.4038723,6.7912151 9.0214171,6.7588185 9.642364,6.7264135 9.822352,7.2249723 9.825935,7.7415248 c 0.02041,2.4801682 0.02268,4.9621352 0.01588,7.4441012 z m 3.903853,-7.319912 c -0.296981,2.463969 -0.608361,4.924337 -0.926907,7.386507 -0.06463,0.496753 -0.329363,0.923314 -0.876519,0.844122 -0.588539,-0.0864 -0.689363,-0.568746 -0.615548,-1.108695 0.165544,-1.204089 0.298771,-2.411776 0.453565,-3.617663 0.15466,-1.205888 0.313172,-2.4099754 0.458941,-3.6176595 0.06305,-0.5183525 0.215887,-1.0079049 0.833341,-0.9629088 0.619131,0.044992 0.734331,0.5633441 0.673127,1.0762973 z M 7.6351893,1.5573077 C 7.937567,0.04724831 8.0941302,-0.10933758 9.107437,0.04904651 c 1.724259,0.26997627 1.76925,0.32577123 1.544247,2.00501369 1.331898,0.2357791 2.665543,0.4913531 4.006422,0.7019334 0.581375,0.091797 1.103312,0.2267786 1.004326,0.9467106 C 15.556303,4.4730319 14.931706,4.3668439 14.409746,4.2804506 11.314017,3.7621003 8.2201245,3.22215 5.1262096,2.6893997 4.4530831,2.5724083 3.781748,2.4374246 3.1049931,2.3366314 2.5614441,2.2556288 2.2482722,1.9730664 2.341861,1.4205189 2.439146,0.85357146 2.8728243,0.72578327 3.3839678,0.81397484 4.8022434,1.056954 6.2187278,1.3089314 7.6351893,1.5573077 Z"
            class="svg"
            style="fill-opacity:1;stroke-width:0.0179983"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex';
export default {
  props: ["item"],
  setup(props){
    const store = useStore()
    function deleteItem(){
      store.commit("removeComplete", props.item);
    }
    function goBack(){
      let obj = {
          id: props.item.id,
          title: props.item.title,
          note: props.item.note,
          dateFinish: ""
        };
      store.commit("addTask", obj);
      store.commit("removeComplete", props.item);
    }

    return {deleteItem, goBack}
  }
};
</script>

<style scoped>
.complete-card {
  border-radius: 20px;
  background: lightyellow;
  border: 4px solid #506070;
  max-width: 400px;
  position: relative;
}
.complete-card-btn {
  width: 100%;
  position: absolute;
  bottom: -15px;
  right: 20px;
  display: flex;
  justify-content: flex-end;
}
.complete-card-btn div {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  border: 3px solid #506070;
  background: lightyellow;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.complete-card-btn div:not(:last-child) {
  margin-right: 8px;
}
.complete-card-btn div:hover {
  background: #506070;
  color: lightyellow;
}
.complete-card-btn div .svg {
  fill: #506070;
}
.complete-card-btn div:hover .svg {
  fill: lightyellow;
}
.complete-time {
  background: #506070;
  border-radius: 20px 20px 0 0;
  padding: 10px 10px 5px;
  display: flex;
  align-items: center;
  color: #fff;
  position: relative;
}
.complete-time::after {
  content: "";
  position: absolute;
  right: -13px;
  width: 20px;
  height: 20px;
  transform: rotate(-45deg);
  background: #506070;
}
.complete-date {
  font-weight: bold;
  font-size: 48px;
  margin-right: 5px;
}
.complete-day {
  padding-right: 10px;
  border-right: 3px solid #fff;
}
.complete-weekday {
  font-weight: bold;
}
.complete-month {
  font-size: 14px;
}
.complete-hour {
  padding-left: 5px;
  font-size: 32px;
  color: #fff;
}
.complete-item {
  padding: 20px;
}
</style>